export const POLYGONJS_LOGO_URL = '/editor/assets/icon.256.png';
